import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Kpi, Panel } from "@/components/common";
import { Button } from "@/components/ui/button";
import { ShieldCheck } from "lucide-react";

export default function Dashboard() {
  const { user, can } = useAuth();
  const [twa, setTwa] = useState(null);
  const [apps, setApps] = useState(null);
  useEffect(() => {
    if (can("twa.view")) api.get("/accounting/twa-dashboard").then((r) => setTwa(r.data.counts));
    if (can("registration.review")) api.get("/admin/registration/applications").then((r) => setApps(r.data));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (user.role === "system_admin") return <Navigate to="/app/admin/users" replace />;
  if (user.role === "help_desk") return <Navigate to="/app/support" replace />;
  return (
    <div className="space-y-8">
      <PageHeader eyebrow={user.role_label} title={`Magandang araw, ${user.name?.split(" ")[0] || ""}`} description="Your CASURECO II workspace." />
      {!user.twofa.enabled && (
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 bg-amber-50 border border-amber-200 rounded-lg p-4" data-testid="2fa-banner">
          <div className="flex gap-3 items-center text-sm text-amber-900"><ShieldCheck className="h-5 w-5" />
            {user.twofa.required_by_policy ? "Two-Factor Authentication is required for your role." : "Add Two-Factor Authentication to better protect your account."}</div>
          <Button asChild size="sm"><Link to="/app/profile" data-testid="2fa-banner-link">Set up 2FA</Link></Button>
        </div>
      )}
      {twa && (
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
          <Kpi label="Confirmed TWA" value={twa.confirmed} tone="emerald" to="/app/twa" testId="dash-twa-confirmed" />
          <Kpi label="Pending TWA assessment" value={twa.pending_assessment} tone="amber" to="/app/twa" />
          <Kpi label="Awaiting WHT review" value={twa.transactions_awaiting_wht_review} tone="rose" to="/app/payments" />
        </div>
      )}
      {apps && (
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
          <Kpi label="Submitted applications" value={apps.filter((a) => a.status === "submitted").length} tone="blue" to="/app/applications" testId="dash-apps-submitted" />
          <Kpi label="Under review" value={apps.filter((a) => a.status === "under_review").length} tone="amber" to="/app/applications" />
          <Kpi label="Needs more info" value={apps.filter((a) => a.status === "additional_info_required").length} tone="slate" to="/app/applications" />
        </div>
      )}
      {user.role === "consumer" && (
        <div className="grid md:grid-cols-2 gap-4">
          <Panel title="My accounts" description="View linked CASURECO II accounts and bills."><Button asChild variant="outline"><Link to="/app/my-accounts">Open</Link></Button></Panel>
          <Panel title="Registration applications" description="Register an existing account or apply for a new service."><Button asChild><Link to="/app/my-applications" data-testid="dash-my-applications">Open applications</Link></Button></Panel>
        </div>
      )}
    </div>
  );
}
